import { render, staticRenderFns } from "./WowzaServer.vue?vue&type=template&id=39b5370e&scoped=true&"
import script from "./WowzaServer.vue?vue&type=script&lang=js&"
export * from "./WowzaServer.vue?vue&type=script&lang=js&"
import style0 from "./WowzaServer.vue?vue&type=style&index=0&id=39b5370e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b5370e",
  null
  
)

export default component.exports